// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { orderTermsStyles } from "@pace/App/Widgets/Common/NonStockItems";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { css } from "styled-components";

orderTermsStyles.boxContainer = {
    css: css`
        margin: 32px 0;
    `,
};
orderTermsStyles.textTitle = {
    variant: "h6",
    forwardAs: "h2",
    css: css`
        margin-bottom: 12px;
    `,
};
orderTermsStyles.secondTextTitle = {
    variant: "h6",
    forwardAs: "h2",
    css: css`
        margin-bottom: 0;
    `,
};
orderTermsStyles.description = {
    forwardAs: "p",
    size: 14,
    lineHeight: "22px",
    weight: fontConfig.weight.regular,
    css: css`
        width: 100%;
        margin-bottom: 4px;
    `,
};
orderTermsStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

orderTermsStyles.descriptionItemContainer = {
    css: css`
        flex-direction: column;
    `,
};
orderTermsStyles.buttonItemContainer = {
    css: css`
        align-items: end;
        gap: 13px;
        display: flex;
    `,
};
orderTermsStyles.addToCartButton = {
    css: css`
        flex: 1 1 0;
    `,
};

orderTermsStyles.editableQuantityTextField = {
    container: {
        css: css`
            align-items: flex-start;
            flex-direction: column;
        `,
    },
};
